import React from "react";
import Image from "next/image";
import Link from "next/link";
import Badge from "../reusable/Badge";

const BlogCardDesign3 = ({ img, title, subheading, slug, styleClass = "", badge }) => {
  return (
    <Link href={`/blog/${slug}`} passHref>
      <div className={`group relative bg-white rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer ${styleClass}`}>
        
        {/* Image section */}
        <div className="relative w-full h-56 sm:h-64 md:h-72 lg:h-64">
          <Image
            src={img}
            alt={title}
            layout="fill"
            objectFit="cover"
            className="transition-transform duration-300 group-hover:scale-105"
            priority
          />
          {badge && <Badge txt={badge} style="absolute top-4 left-4 z-10" />}
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        </div>

        {/* Text content */}
        <div className="p-6 flex flex-col justify-between h-[260px]">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 line-clamp-2">
              {title}
            </h2>
            <p className="text-sm text-gray-600 line-clamp-3">
              {subheading}
            </p>
          </div>

          <div className="mt-4">
            <span className="inline-block px-4 py-2 bg-[#F1AA4E] text-white text-xs font-medium rounded-lg transition hover:bg-[#e19940]">
              Read Full Case Study →
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCardDesign3;
